import { Box, Button, Grid2, Modal, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { viewPDF } from "../../utils/viewPDF";
import axios from "axios";
import html2pdf from "html2pdf.js";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const SingleVendor = () => {
  const [vendor, setVendor] = useState();
  const { tenderId, vtqId } = useParams();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const pdfRef = useRef();
  const [status, setStatus] = useState();
  const [reason, setReason] = useState("");
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [btnLoading, setBtnLoading] = useState(false);

  const validateForm = () => {
    const newErrors = {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    if (isEmpty(reason)) newErrors.reason = "Reason is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleOpen = (s) => {
    setOpen(true);
    setStatus(s);
  };
  const handleClose = () => {
    setOpen(false);
    setStatus("");
    setReason("");
  };

  useEffect(() => {
    const getVTQ = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/vtq/get-by-id?vtqId=${vtqId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setVendor(res.data);
      } catch (error) {
        console.error("Error updating vendor status:", error);
      }
    };
    getVTQ();
  }, []);

  const handleVendorTenderUpdate = async (updatedStatus) => {
    if (updatedStatus !== "REVIEW_LATER"){
      if (!validateForm()) return;
    }
    setBtnLoading(true);
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/vendor-tender`,
        [
          {
            vtId: vendor.vendorTender.vtId,
            status: updatedStatus,
            username: storedUser.username,
            comment: reason,
          },
        ],
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      if (tenderId) {
        navigate(`/dashboard/${tenderId}`);
      } else {
        navigate(`/dashboard`);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleExportPDF = () => {
    const original = pdfRef.current;
    const clone = original.cloneNode(true);
    clone.classList.add("pdf-mode");
    document.body.appendChild(clone); // Temporarily add it to DOM

    html2pdf()
      .from(clone)
      .set({
        margin: 10,
        filename: "Vendor_Qualification_Details.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { format: "a4", orientation: "portrait" },
      })
      .save()
      .then(() => {
        clone.remove(); // Clean up after export
      });
  };

  const handleBack = () => {
    if (tenderId) {
      navigate(`/dashboard/${tenderId}`);
    } else if (localStorage.getItem("activeTab")) {
      navigate(`/dashboard`);
    } else if (localStorage.getItem("action")) {
      navigate(`/dashboard/pending-actions`);
    }
  };
  return (
    <div style={{ position: "relative" }}>
      {btnLoading && <div className="loading-div"></div>}
      <Typography variant="h4">Vendor Qualification Preview</Typography>
      <div style={{ display: "flex", justifyContent: "end" }}>
        <Button className="btn-outlined" onClick={handleExportPDF}>
          Export PDF
        </Button>
      </div>
      <div ref={pdfRef}>
        <Box className="dashboard-container" py={7} px={15}>
          <Typography className="form-title">Basic Information</Typography>
          <Grid2 container>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderTop: "1px solid #000" }}
            >
              Vendor Name (as per government ID)
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{
                borderTop: "1px solid #000",
                borderRight: "1px solid #000",
              }}
            >
              {vendor && vendor.name}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Phone Number
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {vendor && vendor.mobile}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Email ID
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {vendor && vendor.email}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Business Registration Certificates
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {vendor && vendor.businessRegistration && (
                <Button
                  sx={{
                    margin: "0 !important",
                    padding: "0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() =>
                    viewPDF(vendor.businessRegistration, storedUser)
                  }
                >
                  {vendor.businessRegistrationFilename}
                </Button>
              )}
            </Grid2>
          </Grid2>

          <Typography className="form-title">Financial Information</Typography>
          <Grid2 container>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderTop: "1px solid #000" }}
            >
              PAN
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{
                borderTop: "1px solid #000",
                borderRight: "1px solid #000",
              }}
            >
              {vendor && vendor.pan}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              GSTIN
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {vendor && vendor.gstin}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Bank Name
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {vendor && vendor.bankName}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Bank Account Number
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {vendor && vendor.accountNumber}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              IFSC Code
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {vendor && vendor.ifsc}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Bank Account Type
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {vendor && vendor.accountType}
            </Grid2>
          </Grid2>

          <Typography className="form-title">Compliance and Legal</Typography>
          <Grid2 container>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderTop: "1px solid #000" }}
            >
              Business License
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{
                borderTop: "1px solid #000",
                borderRight: "1px solid #000",
              }}
            >
              {vendor && vendor.businessLicense && (
                <Button
                  sx={{
                    margin: "0 !important",
                    padding: "0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() => viewPDF(vendor.businessLicense, storedUser)}
                >
                  {vendor.businessLicenseFilename}
                </Button>
              )}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Insurance Certificates
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {vendor && vendor.insurance && (
                <Button
                  sx={{
                    margin: "0 !important",
                    padding: "0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() => viewPDF(vendor.insurance, storedUser)}
                >
                  {vendor.insuranceFilename}
                </Button>
              )}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Compliance with industry-specific regulations
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {vendor && vendor.compliance && (
                <Button
                  sx={{
                    margin: "0 !important",
                    padding: "0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() => viewPDF(vendor.compliance, storedUser)}
                >
                  {vendor.complianceFilename}
                </Button>
              )}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Do you belong to MSME?
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {vendor && vendor.isMSME ? "Yes" : "No"} 
            </Grid2>
          </Grid2>

          <Typography className="form-title">Operational Details</Typography>
          <Grid2 container>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderTop: "1px solid #000" }}
            >
              Products/Services Offered
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{
                borderTop: "1px solid #000",
                borderRight: "1px solid #000",
              }}
            >
              {vendor && vendor.serviceOffered}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Delivery Terms
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {vendor && vendor.deliveryTerms}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Payment Terms
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {vendor && vendor.paymentTerms}
            </Grid2>
          </Grid2>

          <Typography className="form-title">
            References and Performance
          </Typography>
          <Grid2 container>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderTop: "1px solid #000" }}
            >
              Client References
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{
                borderTop: "1px solid #000",
                borderRight: "1px solid #000",
              }}
            >
              {vendor && vendor.clientReference && (
                <Button
                  sx={{
                    margin: "0 !important",
                    padding: "0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() => viewPDF(vendor.clientReference, storedUser)}
                >
                  {vendor.clientReferenceFilename}
                </Button>
              )}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Performance History
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {vendor && vendor.performanceHistory && (
                <Button
                  sx={{
                    margin: "0 !important",
                    padding: "0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() => viewPDF(vendor.performanceHistory, storedUser)}
                >
                  {vendor.performanceHistoryFilename}
                </Button>
              )}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Certifications and Accreditations
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {vendor && vendor.certifications && (
                <Button
                  sx={{
                    margin: "0 !important",
                    padding: "0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() => viewPDF(vendor.certifications, storedUser)}
                >
                  {vendor.certificationsFilename}
                </Button>
              )}
            </Grid2>
          </Grid2>

          <Typography className="form-title">
            Security and Data Protection
          </Typography>
          <Grid2 container>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderTop: "1px solid #000" }}
            >
              Data Protection Policies
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{
                borderTop: "1px solid #000",
                borderRight: "1px solid #000",
              }}
            >
              {vendor && vendor.dataProtection && (
                <Button
                  sx={{
                    margin: "0 !important",
                    padding: "0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() => viewPDF(vendor.dataProtection, storedUser)}
                >
                  {vendor.dataProtectionFilename}
                </Button>
              )}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Security Measures in Place
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {vendor && vendor.securityMeasures && (
                <Button
                  sx={{
                    margin: "0 !important",
                    padding: "0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() => viewPDF(vendor.securityMeasures, storedUser)}
                >
                  {vendor.securityMeasuresFilename}
                </Button>
              )}
            </Grid2>
          </Grid2>

          <Typography className="form-title">
            Additional Documentation
          </Typography>
          <Grid2 container>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderTop: "1px solid #000" }}
            >
              Audited Financial Statements
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{
                borderTop: "1px solid #000",
                borderRight: "1px solid #000",
              }}
            >
              {vendor && vendor.financialStatements && (
                <Button
                  sx={{
                    margin: "0 !important",
                    padding: "0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() =>
                    viewPDF(vendor.financialStatements, storedUser)
                  }
                >
                  {vendor.financialStatementsFilename}
                </Button>
              )}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Bank Statements
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {vendor && vendor.bankStatements && (
                <Button
                  sx={{
                    margin: "0 !important",
                    padding: "0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() => viewPDF(vendor.bankStatements, storedUser)}
                >
                  {vendor.bankStatementsFilename}
                </Button>
              )}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Any other relevant documents as per company policy
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {vendor && vendor.others && (
                <Button
                  sx={{
                    margin: "0 !important",
                    padding: "0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() => viewPDF(vendor.others, storedUser)}
                >
                  {vendor.othersFilename}
                </Button>
              )}
            </Grid2>
          </Grid2>
        </Box>
      </div>

      <Box className="btn-container" sx={{ gap: 3, width: "100%" }}>
        <Button
          className="btn-outlined"
          onClick={handleBack}
          sx={{ border: "1px solid #1A71F6 !important" }}
        >
          Back
        </Button>
        {storedUser.userRole[0] === "BUYER" &&
        vendor &&
        vendor.vendorTender.vtStatus === "QDETAILS_SUBMITTED" ? (
          <>
            <Button
              className="btn-outlined"
              onClick={() => handleVendorTenderUpdate("REVIEW_LATER")}
            >
              Review Later
            </Button>
            <Button
              className="btn-outlined btn-reject"
              onClick={() => handleOpen("DISQUALIFIED")}
            >
              Reject
            </Button>
            <Button
              className="btn-contained"
              onClick={() => handleOpen("QSTAGE_1")}
            >
              Accept
            </Button>
          </>
        ) : null}

        {storedUser.userRole[0] === "TECHNICAL_HEAD" &&
        vendor &&
        vendor.vendorTender.vtStatus === "QSTAGE_1" ? (
          <>
            <Button
              className="btn-outlined"
              onClick={() => handleVendorTenderUpdate("REVIEW_LATER")}
            >
              Review Later
            </Button>
            <Button
              className="btn-outlined btn-reject"
              onClick={() => handleOpen("DISQUALIFIED")}
            >
              Reject
            </Button>
            <Button
              className="btn-contained"
              onClick={() => handleOpen("QSTAGE_2")}
            >
              Accept
            </Button>
          </>
        ) : null}

        {storedUser.userRole[0] === "PURCHASE_HEAD" &&
        vendor &&
        vendor.vendorTender.vtStatus === "QSTAGE_2" ? (
          <>
            <Button
              className="btn-outlined"
              onClick={() => handleVendorTenderUpdate("REVIEW_LATER")}
            >
              Review Later
            </Button>
            <Button
              className="btn-outlined btn-reject"
              onClick={() => handleOpen("DISQUALIFIED")}
            >
              Reject
            </Button>
            <Button
              className="btn-contained"
              onClick={() => handleOpen("QUALIFIED")}
            >
              Accept
            </Button>
          </>
        ) : null}
      </Box>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h5" fontWeight={"bold"}>
            {status === "DISQUALIFIED"
              ? "Reject the Vendor"
              : "Accept the Vendor"}
          </Typography>
          <label htmlFor="reason">
            Please give reason for{" "}
            {status === "DISQUALIFIED" ? "Reject" : "Accept"}ing the vendor*
          </label>
          <textarea
            className={`${errors.reason && "input-error"}`}
            name="reason"
            id="reason"
            onChange={(e) => {
              setReason(e.target.value);
              setErrors({ reason: "" });
            }}
            rows={8}
          ></textarea>
          {errors.reason && <p className="error">{errors.reason}</p>}
          <Box className="btn-container" sx={{ gap: 3, width: "100%" }}>
            <Button className="btn-outlined" onClick={handleClose}>
              Close
            </Button>
            <Button
              className={
                status === "DISQUALIFIED"
                  ? "btn-outlined btn-reject"
                  : "btn-contained"
              }
              onClick={() => handleVendorTenderUpdate(status)}
              disabled={btnLoading}
            >
              {btnLoading
                ? "Submitting..."
                : status === "DISQUALIFIED"
                ? "Reject"
                : "Accept"}
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default SingleVendor;
